<template>
  <div class="reset-password">
    <div class="reset-password__card">
      <div class="reset-password__brand">
        <img class="reset-password__logo" :src="$brand.logo" :alt="$brand.name" />
        <div>
          <h1 class="reset-password__brand-name">{{ $brand.name }}</h1>
          <p class="reset-password__brand-tag">{{ $t('shell.workspace') }}</p>
        </div>
      </div>

      <h2 class="reset-password__title">{{ $t('password-reset-view.title') }}</h2>
      <p class="reset-password__sub">{{ $t('password-reset-view.hints') }}</p>

      <ValidationObserver v-slot="{ invalid, handleSubmit }">
        <form @submit.prevent="handleSubmit(resetPassword)" novalidate>
          <OmxField
              v-model="email"
              type="email"
              :label="$t('password-reset-view.email-placeholder')"
              :placeholder="$t('password-reset-view.email-placeholder')"
              icon="email-outline"
              rules="required|email"
              required
              autocomplete="email"
              tabindex="1"
              @enter="handleSubmit(resetPassword)"
          />

          <b-button
              native-type="submit"
              type="is-primary"
              :loading="isLoading"
              :disabled="invalid || isLoading"
              expanded
              size="is-medium"
              tabindex="2"
          >{{ $t('password-reset-view.send-password-reset-button') }}</b-button>

          <b-button
              expanded
              class="reset-password__cancel"
              @click="cancel"
              tabindex="3"
          >{{ $t('common.cancel') }}</b-button>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import { ValidationObserver } from "vee-validate";
import OmxField from "@/components/OmxField.vue";

export default {
  name: "PasswordReset",
  components: { ValidationObserver, OmxField },
  data() {
    return {
      email: "",
      isLoading: false
    };
  },
  methods: {
    resetPassword() {
      this.isLoading = true;
      firebase.auth()
          .sendPasswordResetEmail(this.email)
          .then(() => {
            this.isLoading = false;
            this.showSuccess(this.$t("password-reset-view.password-reset-sent"));
          })
          .catch((error) => {
            this.isLoading = false;
            this.showError(error.message);
          });
    },
    cancel() {
      this.$router.back();
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/tokens";

.reset-password {
  min-height: 100vh;
  background:
      radial-gradient(circle at 90% 0%, rgba(255, 175, 55, .18), transparent 45%),
      radial-gradient(circle at 0% 100%, rgba(54, 146, 219, .14), transparent 50%),
      $omx-bg;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
}

.reset-password__card {
  width: 100%;
  max-width: 420px;
  background: $omx-surface;
  border-radius: $omx-radius-xl;
  box-shadow: $omx-shadow-lg;
  border: 1px solid $omx-ink-100;
  padding: 32px;
}

.reset-password__brand {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 22px;
}
.reset-password__logo {
  width: 38px; height: 38px;
  border-radius: 10px;
  object-fit: contain;
  background: #fff;
  padding: 3px;
}
.reset-password__brand-name {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: $omx-ink-900;
}
.reset-password__brand-tag {
  margin: 0;
  font-size: 12px;
  color: $omx-ink-500;
}

.reset-password__title {
  margin: 0 0 6px;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -.012em;
  color: $omx-ink-900;
}
.reset-password__sub {
  margin: 0 0 22px;
  font-size: 13px;
  color: $omx-ink-500;
  line-height: 1.5;
}

.reset-password__cancel {
  margin-top: 8px;
}
</style>
